function i(s, c) {
  let u = 0, a = 1e3 / c, e, t;
  const o = (l, n = Date.now()) => {
    u = n, e = null, t && (clearTimeout(t), t = null), s(...l);
  };
  return [(...l) => {
    const n = Date.now(), r = n - u;
    r >= a ? o(l, n) : (e = l, t || (t = setTimeout(() => {
      t = null, o(e);
    }, a - r)));
  }, () => e && o(e)];
}
export {
  i as default
};
//# sourceMappingURL=index.es418.js.map
